import { Tooltip } from "../../../../../../components/common/tooltip";
import { TitleSubtitle } from "../../../../../../components/listViewTemplates";
import UserProfilePicture from "../../../../../../components/userProfilePicture/UserProfilePicture";
import { type IOwnerItemModel } from "../../../../types";
import "./ownerInfoCell.scss";

const style = {
  width: "17rem",
};

export interface OwnerInfoCellProps {
  user: IOwnerItemModel;
  isSelected: boolean;
  url?: string;
  inherited?: boolean;
}

const OwnerInfoCell = ({ user, isSelected, url, inherited }: OwnerInfoCellProps) => (
  <div className="name-column-value-container">
    <UserProfilePicture imageUrl={user.imageUrl} />
    <TitleSubtitle
      title={`${user.firstName} ${user.lastName}`}
      subtitle={user.email}
      url={url}
      label={
        isSelected ? (
          <Tooltip
            target={<div className={"owner"}>OWNER</div>}
            content={
              inherited
                ? "A group owner has permisssions to review, approve or decline inherited groups"
                : "A group owner has permissions to add, remove or approve group members."
            }
            position="top center"
            styles={style}
            hideOnScroll
            showAlways
          />
        ) : undefined
      }
    />
  </div>
);

export default OwnerInfoCell;
